/**
 * Returns true when media should show the protected overlay in feed views.
 * - logged_in_required: gated only for unauthenticated visitors
 * - everything else (subscription, password, paid): always gated in feeds
 */
export const isGated = (accessLevel, isAuthenticated, hasSubscription = false) => {
    if (!accessLevel || accessLevel === 'public') return false;
    if (accessLevel === 'logged_in_required') return !isAuthenticated;
    if (accessLevel === 'subscription_required') return !hasSubscription;
    return true;
};

const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

/**
 * Returns a short overlay pill label describing what the user must do to
 * access protected media. `action` is 'view' (default) or 'listen'.
 */
export const getAccessLabel = (accessLevel, action = 'view') => {
    const a = cap(action);
    switch (accessLevel) {
        case 'logged_in_required':    return `Login To ${a}`;
        case 'subscription_required': return `Support To ${a}`;
        case 'password_protected':    return `Password Required To ${a}`;
        case 'paid':                  return `Purchase Required To ${a}`;
        default:                      return `Click To ${a}`;
    }
};
